import React from 'react';
import FormView from '../../FormView/index';
import { ISettingsProps } from '../interfaces';
import { useRetrieveCustomerDetails } from 'api/customerEnquiry/details';

const pathToTabMap: Record<string, string> = {
  '/customer-enquiry/settings/general': 'CustomerSetting',
  '/customer-enquiry/settings/financial': 'SettingsFinancial',
};

const Settings: React.FC<ISettingsProps> = ({
  onInitialLoad,
  selectedTab,
  selectedCustomer,
  selectedCustomerSchema,
  isBrowseLookUpOpen,
  selectedForm,
  operationMode,
  formName,
  path,
}) => {
  const fetchCustomerDetailsMutation = useRetrieveCustomerDetails();

  const [customerData, setCustomerData] = React.useState<{
    initialValues: any;
    valuesSchema: any;
  } | null>(null);

  const fetchCustomerDetails = async () => {
    try {
      const { CustomerDetails } = await fetchCustomerDetailsMutation.mutateAsync({
        CustomerId: parseInt(selectedCustomer.CustomerId),
      });

      setCustomerData({
        initialValues: CustomerDetails?.inlineObject ?? null,
        valuesSchema: CustomerDetails?.schema ?? null,
      });
    } catch (error) {
      setCustomerData(null);
    }
  };

  const fetchHandlers: Record<string, () => Promise<void>> = {
    CustomerSetting: fetchCustomerDetails,
    SettingsFinancial: fetchCustomerDetails,
  };

  React.useEffect(
    () => {
      const fetchDetails = async () => {
        if (!selectedCustomer?.CustomerId) {
          setCustomerData(null);

          return;
        }

        const handler = fetchHandlers[selectedTab];
        if (handler) {
          await handler();
        } else {
          setCustomerData(null);
        }
      };

      fetchDetails();
    },
    [selectedTab, selectedCustomer, selectedCustomerSchema]
  );

  React.useEffect(
    () => {
      if (path) {
        const tab = pathToTabMap[path] ?? '';
        onInitialLoad(tab);
      }
    },
    [path, onInitialLoad]
  );

  return (
    selectedForm && (
      <React.Fragment>
        <FormView
          formName={formName}
          browseLookUpOpen={isBrowseLookUpOpen}
          includeTabsHeight={false}
          schema={selectedForm}
          initialValues={customerData?.initialValues ?? null}
          operationMode={operationMode}
          valuesSchema={customerData?.valuesSchema ?? null}
        />
      </React.Fragment>
    )
  );
};

export default Settings;
